module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    ref: "createUserForm",
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.validateBeforeCreateUser($event)
      }
    }
  }, [_c('b-card', {
    staticClass: "mb-3",
    attrs: {
      "header": _vm.$t('userAdministration.userDetails')
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userLogin')
    }
  }, [_c('b-form-input', {
    class: {
      'error': _vm.$v.user.login.$error
    },
    attrs: {
      "id": "userLoginField",
      "name": "user.login"
    },
    model: {
      value: (_vm.user.login),
      callback: function($$v) {
        _vm.$set(_vm.user, "login", $$v)
      },
      expression: "user.login"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userName')
    }
  }, [_c('b-form-input', {
    class: {
      'error': _vm.$v.user.name.$error
    },
    attrs: {
      "name": "user.name"
    },
    model: {
      value: (_vm.user.name),
      callback: function($$v) {
        _vm.$set(_vm.user, "name", $$v)
      },
      expression: "user.name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('userAdministration.userEmail')
    }
  }, [_c('b-form-input', {
    class: {
      'error': _vm.$v.user.email.$error
    },
    attrs: {
      "type": "email",
      "name": "user.email"
    },
    model: {
      value: (_vm.user.email),
      callback: function($$v) {
        _vm.$set(_vm.user, "email", $$v)
      },
      expression: "user.email"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-card', {
    attrs: {
      "header": _vm.$t('userAdministration.userRoles')
    }
  }, [_c('div', {
    staticClass: "ml-2 custom-controls-stacked",
    attrs: {
      "role": "group"
    }
  }, _vm._l((_vm.availableRoles), function(role) {
    return (role.valid_role) ? _c('b-form-checkbox', {
      key: role.name,
      attrs: {
        "value": role.name
      },
      model: {
        value: (_vm.selectedRoles),
        callback: function($$v) {
          _vm.selectedRoles = $$v
        },
        expression: "selectedRoles"
      }
    }, [_vm._v(_vm._s(role.localized_name))]) : _vm._e()
  }), 1)]), _vm._v(" "), (_vm.availableClaims.length > 0) ? _c('b-card', {
    staticClass: "mt-3",
    attrs: {
      "header": _vm.$t('userAdministration.userClaims')
    }
  }, [_c('div', {
    staticClass: "ml-2 custom-controls-stacked",
    attrs: {
      "role": "group"
    }
  }, _vm._l((_vm.availableClaims), function(claim) {
    return _c('b-form-checkbox', {
      key: claim.text,
      attrs: {
        "value": claim.value
      },
      model: {
        value: (_vm.selectedClaims),
        callback: function($$v) {
          _vm.selectedClaims = $$v
        },
        expression: "selectedClaims"
      }
    }, [_vm._v(_vm._s(claim.text))])
  }), 1)]) : _vm._e(), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "userLoginField",
      "placement": "bottom",
      "triggers": "focus"
    }
  }, [_c('b-row', {
    staticClass: "m-0 p-2"
  }, [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userLoginRequirement.0')))]), _vm._v(" "), _c('b-row', {
    staticClass: "m-0 p-2"
  }, [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userLoginRequirement.1')))]), _vm._v(" "), _c('b-row', {
    staticClass: "m-0 p-2"
  }, [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userLoginRequirement.2')))]), _vm._v(" "), _c('b-row', {
    staticClass: "m-0 p-2"
  }, [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userLoginRequirement.3')))]), _vm._v(" "), _c('b-row', {
    staticClass: "m-0 p-2"
  }, [_vm._v("* " + _vm._s(_vm.$t('userAdministration.userLoginRequirement.4')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.createLocalUserModal",
      modifiers: {
        "createLocalUserModal": true
      }
    }],
    attrs: {
      "variant": "success",
      "disabled": _vm.load
    }
  }, [_vm._v("\r\n                    " + _vm._s(_vm.$t('userAdministration.apply')) + "\r\n                    "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    attrs: {
      "id": "createLocalUserModal",
      "ok-title": _vm.$t('forms.submit'),
      "cancel-title": _vm.$t('forms.cancel')
    },
    on: {
      "ok": _vm.validateBeforeCreateUser
    }
  }, [_vm._v("\r\n            " + _vm._s(_vm.$t('userAdministration.userCreateConfirmation')) + "\r\n        ")])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-48d8bdc2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48d8bdc2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-img":"src"}}!./src/components/home/user-administration/user-create/user-create.html
// module id = 780
// module chunks = 1